
define('text!common/views/history/tag.html',[],function () { return '<li class="inline-list__item">\n    <a href="/<%=id%>" class="button button--small button--tag button--secondary" data-link-name="<%=index%> | <%=name%>"><%=name%></a>\n</li>\n';});

